import { render, staticRenderFns } from "./BaseLink.vue?vue&type=template&id=536b1334&scoped=true"
import script from "./BaseLink.vue?vue&type=script&lang=ts"
export * from "./BaseLink.vue?vue&type=script&lang=ts"
import style0 from "./BaseLink.vue?vue&type=style&index=0&id=536b1334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536b1334",
  null
  
)

export default component.exports